import React from 'react'

import { Container } from 'reactstrap'

//fixed-bottom
export default function Footer() {
  return (
    <Container fluid tag="footer" className="text-center  text-white text-uppercase  p-3" style={{backgroundColor:"#1a73e8"}}>
    
    Github Search App with Firbase © Sumana
    </Container>
  )
}
